(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('refreshButton', ["path", "$rootScope", function (path, $rootScope) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('common').directive('refresh-button').template(),
            scope: { options: '<refreshButton' },
            link: function ($scope, element, attrs) {
                $scope.isRefreshing = false;
                $scope.spinClass = function () {
                    return { 'fa-spin': $scope.isRefreshing };
                };
                $scope.triggerRefresh = function () {
                    if ($scope.isRefreshing) {
                        return;
                    }
                    $scope.isRefreshing = true;
                    if ($scope.options && $scope.options.onClickedMsg) {
                        $rootScope.$broadcast($scope.options.onClickedMsg);
                    }
                };
                if ($scope.options && $scope.options.onFinishedMsg) {
                    $scope.$on($scope.options.onFinishedMsg, function () {
                        $scope.isRefreshing = false;
                    });
                }
            }
        };
    }]);
}());